import React from 'react';
import img1 from '../assets/upload1.png';
import img2 from '../assets/upload2.jpg';
import img3 from '../assets/upload3.jpg';
import img4 from '../assets/upload4.jpg';
import img5 from '../assets/upload5.jpg';
import img6 from '../assets/upload6.jpg';
import img7 from '../assets/upload7.jpg';
import img8 from '../assets/upload8.jpg';
import image9 from '../assets/cnfz.png';

const Uploads = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6 text-white">Uploads</h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div className="relative group">
            <img src={img1} alt="upload1.png" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img2} alt="upload2.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img3} alt="upload3.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img4} alt="upload4.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img5} alt="upload5.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img6} alt="upload6.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img7} alt="upload7.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={img8} alt="upload8.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image9} alt="cnfz.png" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Uploads;